import React from 'react'
import Stats from '../stats'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import AuditLogOverview from './audit-log/index'
import Issues from './Issues'

function OverviewTab() {
  return (
    <>
      <Row>
        <Col sm={12}>
          <div className="mb-4">
            <Stats />
          </div>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col sm={5}>
          <Card>
            <Card.Body>
              <Issues />
            </Card.Body>
          </Card>
        </Col>
        <Col sm={7}>
          <Card>
            <Card.Body>
              <AuditLogOverview />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default OverviewTab
